export default __webpack_public_path__ + "static/media/bgHead.b446ef9c.png";